import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';

interface SwiperContextType {
  activeIndex: number;
  setActiveIndex: (index: number) => void;
}

const SwiperContext = createContext<SwiperContextType | undefined>(undefined);

export const SwiperProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const contextValue = useMemo(
    () => ({
      activeIndex,
      setActiveIndex,
    }),
    [activeIndex],
  );

  return <SwiperContext.Provider value={contextValue}>{children}</SwiperContext.Provider>;
};

export const useSwiperContext = () => {
  const context = useContext(SwiperContext);
  if (!context) {
    throw new Error('useSwiperContext must be used within a SwiperProvider');
  }
  return context;
};
